import { useFlag } from '@unleash/proxy-client-react'
import { getAuth } from 'firebase/auth'
import { useLocation } from 'react-router-dom'
import CurrentBucketMenu from './CurrentBucketMenu'
import ProfileDropDown from './ProfileDropDown'

interface Props {
  currentBucketMenu?: boolean
}

export default function SettingsMenu({ currentBucketMenu }: Props) {
  const enabledNewBucketSwitcher = useFlag('enabledNewBucketSwitcher')
  const location = useLocation()
  const { pathname } = location
  const isSubscriptionPath = pathname.includes('/subscription')
  const isSharePath = pathname.includes('/share')

  if (!getAuth().currentUser) {
    return null
  }

  if (enabledNewBucketSwitcher && !isSharePath && !isSubscriptionPath) {
    return null
  }

  return (
    <>
      {currentBucketMenu && <CurrentBucketMenu />}
      <ProfileDropDown />
    </>
  )
}

SettingsMenu.defaultProps = {
  currentBucketMenu: true
}
